import { ROLES } from "../../../helpers/commons.helpers";
import destinationRouters from "../modules/destinations/router/destination.routers";
import documentationRouters from "../modules/documentations/router/documentation.routers";
import helpRouters from "../modules/helps/router/help.router";
import vehicleGalleryRouters from "../modules/vehiclesGallery/router/vehicle.gallery.routers";
import eventRouters from "../modules/events/router/event.routers";
/**
 * Tools route definitions.
 *
 * These routes are lazy-loaded and intended to be used as children of the
 * authenticated layout. Each route exposes a `meta` object with common
 * properties used by navigation guards and permission checks.
 *
 * @typedef {Object} ToolRouteMeta
 * @property {Array<string>} modules - Application module keys related to the route.
 * @property {boolean} requiresAuth - When true the route requires an authenticated session.
 * @property {Array<string>} roles - Array of role identifiers allowed to access the route.
 *
 * @type {Array<import('vue-router').RouteConfig>}
 */
export default [
  {
    path: "/tools",
    name: "ToolsManager",
    meta: {
      title: "Tools Manager",
      modules: ["tools"],
      requiresAuth: true,
      roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER]
    },
    component: () =>
      import(
        /* webpackChunkName: "tools" */ "@/modules/tools/pages/ToolsManager.vue"
      )
  },
  ...documentationRouters,
  ...helpRouters,
  ...vehicleGalleryRouters,
  ...destinationRouters,
  ...eventRouters
];
